// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cvat-login-openvino-block>div{text-align:center}.cvat-login-openvino-block>div .ant-divider{margin-bottom:8px}.cvat-login-openvino-block>div>a{margin-top:8px}", ""]);
// Exports
module.exports = exports;
